import { DynamicFilterOptions } from './report-groups-dynamic-filter.types';
import { DeviceModelType, DeviceModelTypeLabel } from '../../../../../../services/data/devices-data/devices-data.types';
import { MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';

export enum FieldName {
  operator = 'operator',
  values = 'values',
  options = 'options'
}

export enum FilterType {
  Radiobutton = 'Radiobutton',
  Multiselect = 'Multiselect'
}

export const InOpFilter = { text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.IN, value: 'IN' };
export const NotInOpFilter = { text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.NOT_IN, value: 'NOT_IN' };
export const DoesNotEqualOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.DOES_NOT_EQUAL,
  value: 'NOT_EQUAL'
};
export const EqualsOpFilter = { text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.EQUALS, value: 'EQUAL' };
export const ContainsOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.CONTAINS,
  value: 'CONTAINS'
};
export const DoesNotContainOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.DOES_NOT_CONTAIN,
  value: 'NOT_CONTAINS'
};
export const GreaterThanOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.GREATER_THAN,
  value: 'GREATER_THAN'
};
export const GreaterThanOrEqualToOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.GREATER_THAN_OR_EQUAL_TO,
  value: 'GREATER_THAN_OR_EQUAL'
};
export const LessThanOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.LESS_THAN,
  value: 'LESS_THAN'
};
export const LessThanOrEqualToOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.LESS_THAN_OR_EQUAL_TO,
  value: 'LESS_THAN_OR_EQUAL'
};
export const LaterThanOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.LATER_THAN,
  value: 'GREATER_THAN'
};
export const LaterThanOrEqualToOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.LATER_THAN_OR_EQUAL_TO,
  value: 'GREATER_THAN_OR_EQUAL'
};
export const EarlierThanOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.EARLIER_THAN,
  value: 'LESS_THAN'
};
export const EarlierThanOrEqualToOpFilter = {
  text: TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.OPERATOR.EARLIER_THAN_OR_EQUAL_TO,
  value: 'LESS_THAN_OR_EQUAL'
};

export const deviceTypeDefaultItems = [
  DynamicFilterOptions.Meter,
  DynamicFilterOptions.MTU,
  DynamicFilterOptions.DCU,
  DynamicFilterOptions.BaseStation,
  DynamicFilterOptions.ExactaGuard,
  DynamicFilterOptions.RMD,
  DynamicFilterOptions.RDD
];

export const deviceStatusDefaultItems = [
  DynamicFilterOptions.Active,
  DynamicFilterOptions.Inactive,
  DynamicFilterOptions.Removed
];

export const modelTypeValueItems = [
  { text: DeviceModelTypeLabel.AMISensorGen1, value: DeviceModelType.AMISensorGen1 },
  { text: DeviceModelTypeLabel.Badger, value: DeviceModelType.Badger },
  { text: DeviceModelTypeLabel.DCU2, value: DeviceModelType.DCU2 },
  { text: DeviceModelTypeLabel.DCU2Plus, value: DeviceModelType.DCU2Plus },
  { text: DeviceModelTypeLabel.Diehl, value: DeviceModelType.Diehl },
  { text: DeviceModelTypeLabel.GenI, value: DeviceModelType.GenI },
  { text: DeviceModelTypeLabel.GenII, value: DeviceModelType.GenII },
  { text: DeviceModelTypeLabel.Generic, value: DeviceModelType.Generic },
  { text: DeviceModelTypeLabel.Kamstrup, value: DeviceModelType.Kamstrup },
  { text: DeviceModelTypeLabel.MasterMeter, value: DeviceModelType.MasterMeter },
  { text: DeviceModelTypeLabel.Neptune, value: DeviceModelType.Neptune },
  { text: DeviceModelTypeLabel.NextGenBaseStation, value: DeviceModelType.NextGenBaseStation },
  { text: DeviceModelTypeLabel.POTS_DCU, value: DeviceModelType.POTS_DCU },
  { text: DeviceModelTypeLabel.S3400, value: DeviceModelType.S3400 },
  { text: DeviceModelTypeLabel.S342X, value: DeviceModelType.S342X },
  { text: DeviceModelTypeLabel.S345X, value: DeviceModelType.S345X },
  { text: DeviceModelTypeLabel.S3500, value: DeviceModelType.S3500 },
  { text: DeviceModelTypeLabel.S35XX, value: DeviceModelType.S35XX },
  { text: DeviceModelTypeLabel.S3600, value: DeviceModelType.S3600 },
  { text: DeviceModelTypeLabel.S36XX, value: DeviceModelType.S36XX },
  { text: DeviceModelTypeLabel.S4kEPM, value: DeviceModelType.S4kEPM },
  { text: DeviceModelTypeLabel.S4kEVC, value: DeviceModelType.S4kEVC },
  { text: DeviceModelTypeLabel.S501S2S3, value: DeviceModelType.S501S2S3 },
  { text: DeviceModelTypeLabel.StandardBaseStation, value: DeviceModelType.StandardBaseStation },
  { text: DeviceModelTypeLabel.Unknown, value: DeviceModelType.Unknown },
  { text: DeviceModelTypeLabel.UsmPf, value: DeviceModelType.UsmPf },
  { text: DeviceModelTypeLabel.ZoneScan, value: DeviceModelType.ZoneScan }
];

export const isMultiselectArray = (values: unknown, filterType?: FilterType): values is MultiselectItem[] => {
  return filterType === FilterType.Multiselect;
};
